<div #dropdown="bs-dropdown" class="language-selector-wrapper" dropdown>
    <div class="d-flex align-items-center" dropdownToggle>
        <p [innerText]="prettifyLanguageCode(getCurrentLanguage())" class="current-language"></p>
        <svg fill="none" height="7" style="margin-left:2px; margin-top:-2px;"
             viewBox="0 0 11 7" width="11" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.07672 4.43901L8.78526 0.677043C8.95052 0.509312 9.21495 0.511023 9.38021 0.680466L10.0297 1.3531C10.195 1.52597 10.195 1.80324 10.028 1.97439L5.37585 6.76157C5.29322 6.84715 5.1858 6.88993 5.07672 6.88993C4.96765 6.88993 4.86022 6.84715 4.77759 6.76157L0.125395 1.97439C-0.0415219 1.80324 -0.0415219 1.52597 0.123743 1.3531L0.773232 0.680466C0.938497 0.511023 1.20292 0.509312 1.36818 0.677043L5.07672 4.43901Z"
                  fill="#898E98"/>
        </svg>
    </div>
    <div *dropdownMenu aria-labelledby="basic-link" class="dropdown-menu dropdown-menu-language"
         [style.height.px]='45 * languages$.length'
         id="basic-link-dropdown" role="menu">
        <div (click)="setLanguage(language)" *ngFor="let language of languages$"
             [ngClass]="{'active' : language.code === ''}"
             class="language-item">
            <a (click)="setLanguage(language)" [innerText]="prettifyLanguageCode(language.code)"
               href="javascript:void(0)"></a>
        </div>
    </div>
</div>


<ng-template #languageSelect>
    <div class="modal-header language-modal-header">
        <h3 class="modal-title">{{'Please select your language' | translate}}</h3>
    </div>
    <div class="language-modal-content">
        <div class="modal-body">
            <div *ngFor="let language of languages$" [ngClass]="{'active' : language.code === ''}"
                 class="language-item-button">
                <a (click)="setLanguage(language)"
                   [innerText]="language.name" href="javascript:void(0)"></a>
            </div>
        </div>
    </div>
</ng-template>
